// @flow
import Record from "../flow/Record";
import { List } from "immutable";
import keymirror from "keymirror";

export const Languages = Object.freeze(
    keymirror({
        en: null,
        de: null,
        zh: null,
        ja: null
    })
);

export const Levels = Object.freeze(
    keymirror({
        native: null,
        fluent: null,
        advanced: null,
        intermediate: null,
        beginner: null
    })
);

export class LanguageSettings extends Record({
    language: "",
    level: "",
    isLearning: false
}) {
    language: string;
    level: string;
    isLearning: boolean;
}

export class UserSettings extends Record({
    id: "",
    displayName: "",
    avatarURL: "",
    emailNotifications: false,
    languages: List(),
    loggedIn: false,
    token: null
}) {
    id: string;
    displayName: string;
    avatarURL: string;
    emailNotifications: boolean;
    languages: List<LanguageSettings>;
    loggedIn: boolean;
    token: string;
}

export function jsToLanguageSettingsRecord(
    languageSettings: any
): LanguageSettings {
    return new LanguageSettings(languageSettings);
}

export function jsToUserSettingsRecord(userSettings: any): UserSettings {
    return new UserSettings({
        ...userSettings,
        languages: List(userSettings.languages || []).map(
            jsToLanguageSettingsRecord
        )
    });
}



// WEBPACK FOOTER //
// ./src/records/userSettings.record.js